<template>

    <dx-data-grid
        style="flex-grow: 1"
        :data-source="dataSource"
        :remote-operations="false"
        :allow-column-reordering="true"
        :row-alternation-enabled="true"
        :show-column-lines="true"
        :show-borders="true"
        :height="50"
        :width="'100%'"
        :column-min-width="50"
        :word-wrap-enabled="true"
        :column-chooser="{ enabled: true, mode: 'select' }"
        @toolbar-preparing="onToolbarPreparing($event)"
    >
        <dx-group-panel :visible="true" />
        <dx-grouping :auto-expand-all="false" :contextMenuEnabled="true" />
        <dx-load-panel :enabled="true" />
        <dx-scrolling mode="virtual" />
        <dx-sorting mode="single" />
        <dx-export :enabled="true" :formats="['pdf', 'excel']" :allow-export-selected-data="true" />

        <dx-column
            :width="55"
            :cell-template="'commandButtonsTemplate'"
        />

        <dx-column
            caption="id"
            data-field="id"
            data-type="number"
            :width="100"
        />

        <dx-column
            caption="№ заявки"
            data-field="number"
            data-type="number"
            :max-width="120"
        />

        <dx-column
            caption="Дата заявки"
            data-field="date"
            data-type="date"
            :max-width="120"
        />

        <dx-column
            caption="Проекты"
            data-field="projects"
            data-type="number"
            cell-template="projectsListTemplate"
        />

        <template #commandButtonsTemplate="{ data: cell }">
            <dx-button
                icon="doc"
                hint="Открыть карточку заявки"
                @click="openRequestCard(cell.data.id)"></dx-button>
        </template>

        <template #projectsListTemplate="{ data: cell }">
            <div
                v-for="project in cell.data.projects"
                v-bind:key="project.id"
                >
                № {{ project.id }}: {{ project.description }}
            </div>
        </template>
    </dx-data-grid>

    <footer-grid :totalCount="totalCount"></footer-grid>

</template>

<script>
export default {
    name: 'arki-requests-list-view'
};
</script>

<script setup>
import { ref, onBeforeMount } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { DxButton } from 'devextreme-vue';
import {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxLoadPanel,
    DxSorting,
    DxExport,
    DxGrouping,
    DxGroupPanel
 //   DxItem
} from 'devextreme-vue/data-grid'

import FooterGrid from '@/components/grid-card-component/footer-grid.vue';
import { baseUrl, appName } from '@/views/arki/services/arki-service';
import { getRequests } from '@/views/arki/services/arki-request-service';
import { getAiToolbar } from '@/components/utils/ai-toolbar-generator';

const
    router = useRouter(),
    route = useRoute(),
    totalCount = ref(0),
    dataSource = ref([]);

onBeforeMount(async () => {
    await reloadData();
});

const reloadData = async () => {
    dataSource.value = await getRequests();
    totalCount.value = dataSource.value?.length || 0;
}

const openRequestCard = (requestId) => {
    const { app, dep } = route.params;
    router.push({ path: `/${baseUrl}/${appName}/request/&/${app}/${dep}/${requestId}` });
};

const onToolbarPreparing = (e) => {
    getAiToolbar(e, {
        refresh: {
            event: async (e) => {
                await reloadData();
            },
        }
    });
}

</script>

<style lang="scss" scoped>

</style>
